import { FloorPlan } from './../../model/floorplan.model';
import { Subject, Subscription } from 'rxjs';
import { Component, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import * as SVGFAIconsSolid from '@fortawesome/free-solid-svg-icons';
import * as SVGFAIconsRegular from '@fortawesome/free-regular-svg-icons';
import { AppState } from 'src/app/app.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-top-panel',
  templateUrl: './top-panel.component.html',
  styleUrls: ['./top-panel.component.scss']
})
export class TopPanelComponent implements OnInit, OnDestroy {

  @Input() selectedTool: Subject<string> = new Subject();

  @Output() toolClick: EventEmitter<string> = new EventEmitter();
  @Output() save: EventEmitter<boolean> = new EventEmitter();
  @Output() send: EventEmitter<boolean> = new EventEmitter();
  @Output() changeScale: EventEmitter<number> = new EventEmitter();

  scaleOptions = [
    {label: 'Default', value: undefined},
    {label: '100', value: 100},
    {label: '200', value: 200},
    {label: '300', value: 300},
    {label: '400', value: 400},
    {label: '500', value: 500},
    {label: '600', value: 600},
    {label: '700', value: 700},
    {label: '750', value: 750},
    {label: '800', value: 800},
    {label: '900', value: 900},
    {label: '1000', value: 1000},
  ];

  disableSave: boolean = false;  
  subscriptions: Subscription[] = [];
  currentAction: string;
  scale: number;

  constructor(
    private store: Store<AppState>
  ) { }

  
  get solidIcons() {
    return SVGFAIconsSolid;
  }

  get regularIcons() {
    return SVGFAIconsRegular;
  }

  ngOnInit() {
    this.subscriptions.push(
      this.selectedTool.subscribe(val => {
        this.currentAction = val;
      })
    );

    this.subscriptions.push(
      this.store.select('floorPlan').subscribe((plan: FloorPlan) => {
        if (plan && plan.testata) {
          this.scale = plan.testata.scala;
        }
      })
    );

    const canmod = localStorage.getItem('canmod');
    this.disableSave = canmod === 'N' ? true : canmod === 'S' ? false : true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    })
  }

  onClickTool(action: string, storeCurrentAction: boolean = true) {
    this.toolClick.emit(action);
    if (storeCurrentAction) {
      this.currentAction = action;
    }
  }

  onChangeScale() {
    if (this.scale) {
      this.changeScale.emit(this.scale);
    }
  }

  onSave() {
    this.save.emit(true);
  }

  onSend() {
    this.send.emit(true);
  }

  getButtonColor(func) {
    if (func === this.currentAction) {
      return 'editor-button-selected';
    } else {
      return 'editor-button-notselected';
    }
  }

}
